import { Navigate, useParams } from "react-router-dom";
import { PageHero } from "@/components/Section";
import Reveal from "@/components/Reveal";
import { legalPages } from "@/data/content";
import { useBrand } from "@/context/BrandContext";

export default function LegalPage() {
  const brand = useBrand();
  const { slug } = useParams();
  const page = legalPages[slug === "food-safety" ? "foodSafety" : slug];

  if (!page) return <Navigate to="/" replace />;

  return (
    <>
      <PageHero  eyebrow={page.updated} title={page.title} />
      <section className="py-14 sm:py-20">
        <div className="mbm-container max-w-3xl">
          <Reveal className="space-y-8">
            {page.sections.map((s) => (
              <div key={s.heading} data-testid={`legal-section-${s.heading.toLowerCase().replace(/\s+/g, "-")}`}>
                <h2 className="font-heading text-lg font-semibold">{s.heading}</h2>
                <p className="mt-2.5 text-sm leading-relaxed text-cocoa/70">{s.body}</p>
              </div>
            ))}
            <div className="mbm-rule" />
            <p className="text-sm leading-relaxed text-cocoa/75">
              Questions about this policy? Write to{" "}
              <a href={`mailto:${brand.contact.email}`} className="font-semibold text-coralInk hover:text-rust">
                {brand.contact.email}
              </a>{" "}
              or message us on WhatsApp. {brand.legalEntity}.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
